module.exports = __webpack_public_path__ + "static/assets/0bf5e11621789f54a2ffbd7df4876ab2.png";